import {
  InternalType,
  PaginatedResponseOrganization as PaginatedOrganizationsDto,
  UserRole as UserRoleDto,
} from '@electricjs/core_entity-client';
import { http, HttpResponse, delay } from 'msw';

import {
  connectedOrganization,
  simpleOrganization,
} from '@/mocks/data/organizationData';
import { OrganizationUserRoleSlugs } from '@/types/users';

const adminOrganizations = [simpleOrganization, connectedOrganization];

export const adminHandlers = [
  http.get('*/v1/admin/organizations', async ({ request }) => {
    const url = new URL(request.url);
    const term = url.searchParams.get('term')?.toLowerCase();
    const limit = Number(url.searchParams.get('limit') ?? 25);
    const offset = Number(url.searchParams.get('offset') ?? 0);

    const matching = term
      ? adminOrganizations.filter(org => org.name.toLowerCase().includes(term))
      : adminOrganizations;
    const response: PaginatedOrganizationsDto = {
      results: matching.slice(offset, offset + limit),
      total: matching.length,
    };

    await delay();
    return HttpResponse.json(response, { status: 200 });
  }),

  http.post(
    '*/v1/admin/organizations/:organizationId/support_users',
    async ({ params, request }) => {
      const body = (await request.json()) as { user_id: string };
      const response: UserRoleDto = {
        organization_id: String(params.organizationId),
        user_id: body.user_id,
        role: {
          id: 'support-role-id',
          slug: OrganizationUserRoleSlugs.PRODUCT_SUPPORT,
        },
      };

      await delay();
      return HttpResponse.json(response, { status: 201 });
    }
  ),

  http.delete(
    '*/v1/admin/organizations/:organizationId/support_users/:userId',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.post(
    '*/v1/admin/organizations/:organizationId/employees/users/admin',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  http.post(
    '*/v1/admin/organizations/:organizationId/employees/users/remove-admins',
    async () => {
      await delay();
      return new HttpResponse(null, { status: 204 });
    }
  ),

  // No blocked status exists on the organization DTO, so nothing to persist.
  http.post('*/v1/admin/organizations/:organizationId/block', async () => {
    await delay();
    return new HttpResponse(null, { status: 204 });
  }),

  http.patch(
    '*/v1/admin/organizations/:organizationId',
    async ({ params, request }) => {
      const organization = adminOrganizations.find(
        org => org.id === params.organizationId
      );
      const body = (await request.json()) as {
        name?: string;
        internal_type?: InternalType;
      };

      await delay();
      if (!organization) {
        return new HttpResponse(null, { status: 404 });
      }
      if (body.name !== undefined) organization.name = body.name;
      if (body.internal_type !== undefined) {
        organization.internal_type = body.internal_type;
      }
      return new HttpResponse(null, { status: 204 });
    }
  ),
];
